/* RLN design system — scroll reveal animations.
   Included from every rln-* section; guarded so it only initializes once. */
(function () {
  if (window.__rlnDesignInit) return;
  window.__rlnDesignInit = true;

  var SELECTORS = [
    '.rln-steps__heading', '.rln-steps__sub', '.rln-steps__card', '.rln-steps__payoff', '.rln-steps__closing',
    '.rln-stat__figure', '.rln-stat__line', '.rln-stat__subline',
    '.rln-reframe__headline', '.rln-reframe__copy', '.rln-reframe__media', '.rln-reframe__cta-wrap',
    '.rln-segments__heading', '.rln-segments__card',
    '.rln-guarantee__seal', '.rln-guarantee__heading', '.rln-guarantee__body', '.rln-guarantee__cta',
    '.rln-reviews__heading', '.rln-reviews__card',
    '.rln-bonus__badge-row', '.rln-bonus__heading', '.rln-bonus__card', '.rln-bonus__close', '.rln-bonus__cta-wrap',
    '.rln-faq__heading', '.rln-faq__item',
    '.rln-specs__heading', '.rln-specs__table',
    '.rln-tiers__card'
  ].join(',');

  function init() {
    var els = document.querySelectorAll(SELECTORS);
    if (!els.length) return;

    // stagger siblings that share a parent (cards in a grid)
    var parents = new Map();
    els.forEach(function (el) {
      var p = el.parentElement;
      var n = parents.get(p) || 0;
      el.style.setProperty('--rln-stagger', Math.min(n, 6));
      parents.set(p, n + 1);
      el.classList.add('rln-reveal');
    });

    if (!('IntersectionObserver' in window)) {
      els.forEach(function (el) { el.classList.add('rln-inview'); });
      return;
    }
    var io = new IntersectionObserver(function (entries) {
      entries.forEach(function (entry) {
        if (entry.isIntersecting) {
          entry.target.classList.add('rln-inview');
          io.unobserve(entry.target);
        }
      });
    }, { rootMargin: '0px 0px -8% 0px', threshold: 0.08 });
    els.forEach(function (el) { io.observe(el); });
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', init);
  } else {
    init();
  }
  // re-run inside the theme editor when sections reload
  document.addEventListener('shopify:section:load', function () {
    window.requestAnimationFrame(init);
  });
})();

